import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Select } from '@repo/design-system-kit';
import LOCALES_ARRAY from 'receivable-invoices-js/constants/locales';
import { useLocaleManager } from 'receivable-invoices-js/react/hooks/use-locale-manager';
import styles from './locale-switcher.module.css';

type LocaleSwitcherProps = ComponentPropsWithoutRef<'div'>;

export function LocaleSwitcher({ className, ...props }: LocaleSwitcherProps): ReactNode {
  const { formatMessage } = useIntl();
  const localeManager = useLocaleManager();

  const selectedLocaleOption = LOCALES_ARRAY.find(({ code }) => code === localeManager.locale);

  const handleUpdateLocale = (selectedKey: string | number): void => {
    const selectedLocale = LOCALES_ARRAY.find(({ code }) => code === selectedKey);
    if (selectedLocale) {
      localeManager.setLocale(selectedLocale.code);
    }
  };

  return (
    <div className={className} {...props}>
      <Select
        aria-label={formatMessage({ id: 'select-language.aria-label' })}
        className={styles.localeSwitcherTrigger}
        data-test-locale-select=""
        onSelectionChange={handleUpdateLocale}
        placeholder=""
        selectedKey={selectedLocaleOption?.code}
      >
        {LOCALES_ARRAY.map(locale => (
          <Select.Option id={locale.code} key={locale.code}>
            <span data-test-locale-select-option>{locale.name}</span>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
